module.exports = __webpack_public_path__ + "img/time-icon.72da7fdc.svg";